/* CENTRIX Floating Glass Menu v1.6.
   Native Shopify drawer at page top; accessible viewport-level glass dialog
   while the approved v1.5 header is floating. No page-scroll anchoring. */
(()=>{
  if(window.__centrixFloatingMenuV16)return;
  window.__centrixFloatingMenuV16=true;
  const svgNS='http://www.w3.org/2000/svg';
  const chromium=/(?:Chrome|Chromium|Edg)\//.test(navigator.userAgent)&&!/(?:FxiOS|CriOS|EdgiOS|Firefox)\//.test(navigator.userAgent);
  const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
  let dialog=null,trigger=null,hideTimer=0,refrFilter=null,refrImage=null,refrDisplacement=null,refrSvg=null;
  /* v1.9 — refraction never runs during the entry/exit bubble animation. */
  let refractionTimer=0,refractionEpoch=0,lastLens=null,resizeFrame=0;
  const clamp=(v,a,b)=>Math.min(b,Math.max(a,v));
  const num=(value,fallback)=>Number.isFinite(Number(value))?Number(value):fallback;
  function findGlass(){return document.querySelector('.header-section > .centrix-liquid-glass__surface');}
  function findSummary(){return document.querySelector('#header-component .header__drawer .menu-drawer-container > summary.header__icon--menu');}
  function readJson(selector){
    const node=document.querySelector(selector);
    if(!node)return null;
    try{return JSON.parse(node.textContent||'null');}catch(e){return null;}
  }
  function currentSettings(){
    const data=readJson('.centrix-floating-menu-v16__config');
    if(!data||data.enabled!==true)return null;
    return data;
  }
  function canUsePopup(summary){
    if(!summary||!summary.isConnected||!summary.getClientRects().length)return false;
    if(typeof HTMLDialogElement==='undefined'||typeof HTMLDialogElement.prototype.showModal!=='function')return false;
    const desktopTrigger=summary.matches?.('.centrix-desktop-glass-trigger')===true;
    if(desktopTrigger){
      const cfg=currentSettings(),header=document.getElementById('header-component');
      if(cfg?.desktopEnabled!==true||!matchMedia('(min-width: 750px)').matches||
         header?.dataset.menuStyle!=='menu')return false;
    }
    const glass=findGlass();
    if(!glass||glass.dataset.centrixGlassEnabled!=='true'||glass.dataset.centrixFloatEnabled!=='true')return false;
    const scrollParent=matchMedia('(min-width: 990px)').matches
      ?(document.querySelector('.page-wrapper')||document.scrollingElement)
      :document.scrollingElement;
    const offset=Math.max(0,scrollParent?.scrollTop||0,window.scrollY||0);
    const threshold=Math.max(0,num(glass.dataset.centrixGlassThreshold,80));
    if(offset<threshold)return false;
    const menu=readJson('.centrix-floating-menu-v16__links');
    return !!(currentSettings()&&Array.isArray(menu)&&menu.length);
  }
  const node=(tag,cls)=>{const el=document.createElement(tag);if(cls)el.className=cls;return el;};
  function sanitizeURL(value){
    if(typeof value!=='string')return '#';
    const u=value.trim();
    if(u.startsWith('/')||u.startsWith('#')||/^(https?:|mailto:|tel:)/i.test(u))return u;
    return '#';
  }
  function appendLinks(items,parent,level=0){
    if(!Array.isArray(items)||level>3)return;
    for(const item of items){
      if(!item||typeof item.title!=='string')continue;
      const li=node('li','centrix-floating-menu-v16__item');
      const line=node('div','centrix-floating-menu-v16__line');
      const link=node('a','centrix-floating-menu-v16__link');
      link.href=sanitizeURL(item.url);
      link.textContent=item.title;
      if(item.current===true)link.setAttribute('aria-current','page');
      line.append(link);
      const children=Array.isArray(item.children)?item.children:[];
      if(children.length){
        const toggle=node('button','centrix-floating-menu-v16__toggle');
        toggle.type='button';
        toggle.setAttribute('aria-label','Expand '+item.title);
        toggle.setAttribute('aria-expanded','false');
        const ul=node('ul','centrix-floating-menu-v16__children');
        ul.hidden=true;
        appendLinks(children,ul,level+1);
        toggle.addEventListener('click',()=>{
          ul.hidden=!ul.hidden;
          toggle.setAttribute('aria-expanded',String(!ul.hidden));
          toggle.setAttribute('aria-label',(ul.hidden?'Expand ':'Collapse ')+item.title);
          /* Measure intrinsic list height after the subnavigation changes. */
          requestAnimationFrame(()=>updateAdaptiveHeight());
        });
        line.append(toggle);
        li.append(line,ul);
      }else li.append(line);
      parent.append(li);
    }
  }
  function ensureDialog(){
    if(dialog?.isConnected)return dialog;
    dialog=node('dialog','centrix-floating-menu-v16');
    dialog.id='centrix-floating-menu-v16';
    dialog.setAttribute('aria-labelledby','centrix-popup-v16-label');
    dialog.setAttribute('aria-modal','true');
    const tint=node('div','centrix-floating-menu-v16__tint');
    tint.setAttribute('aria-hidden','true');
    const shell=node('div','centrix-floating-menu-v16__shell');
    const toolbar=node('div','centrix-floating-menu-v16__toolbar');
    const title=node('span','centrix-floating-menu-v16__title');
    title.id='centrix-popup-v16-label';title.textContent='Menu';
    const close=node('button','centrix-floating-menu-v16__close');
    close.type='button';close.textContent='×';close.setAttribute('aria-label','Close navigation menu');
    close.addEventListener('click',()=>closePopup());
    const nav=node('nav','centrix-floating-menu-v16__navigation');
    nav.setAttribute('aria-label','CENTRIX navigation');
    toolbar.append(title,close);shell.append(toolbar,nav);
    const panel=node('div','centrix-floating-menu-v16__panel');
    panel.id='centrix-floating-menu-v16__panel';
    panel.append(tint,shell);
    /* Dedicated fadeable scrim prevents a sudden native ::backdrop flash. */
    const scrim=node('div','centrix-floating-menu-v16__scrim');
    scrim.setAttribute('aria-hidden','true');
    scrim.addEventListener('click',()=>closePopup());
    /* Transparent top-layer hit area; real header still draws its hamburger. */
    const headerToggle=node('button','centrix-floating-menu-v16__header-toggle');
    headerToggle.type='button';
    headerToggle.setAttribute('aria-label','Close floating navigation menu');
    headerToggle.setAttribute('aria-controls',panel.id);
    headerToggle.setAttribute('aria-expanded','true');
    headerToggle.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();closePopup();});
    dialog.append(scrim,panel,headerToggle);
    dialog.addEventListener('cancel',e=>{e.preventDefault();closePopup();});
    dialog.addEventListener('click',e=>{
      if(e.target===dialog)closePopup();
    });
    dialog.addEventListener('keydown',e=>{
      if(e.key!=='Tab')return;
      const focusables=[...dialog.querySelectorAll('a[href],button:not([disabled])')].filter(x=>x.getClientRects().length);
      if(!focusables.length)return;
      const first=focusables[0],last=focusables[focusables.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    });
    document.body.append(dialog);
    return dialog;
  }
  /* Avoid triggering the mobile compositor when viewport dimensions have not
     materially changed. This can happen dozens of times as browser chrome moves. */
  function setStyle(el,key,value){
    const next=String(value);
    if(el.style.getPropertyValue(key)!==next)el.style.setProperty(key,next);
  }
  /* CENTRIX v1.8: Single source of visual truth for floating header and popup.
     In matched mode, use rendered header settings rather than duplicate saved
     popup values. Independent popup dimensions/behavior always remain editable. */
  function styleDialog(config,summary,glass){
    const glassCSS=getComputedStyle(glass);
    const originalTint=glass.querySelector('.centrix-liquid-glass__tint');
    const tintCSS=originalTint?getComputedStyle(originalTint):null;
    const inherit=config.inherit!==false;
    const headerTint=tintCSS?.backgroundColor||'#202731';
    const headerOpacity=clamp(num(tintCSS?.getPropertyValue('--centrix-tint-opacity'),.38),0,1);
    const headerBlur=clamp(num(glassCSS.getPropertyValue('--centrix-glass-blur').trim().replace('px',''),6),0,45);
    const headerRadiusRaw=num(glassCSS.getPropertyValue('--centrix-glass-outer-radius').trim().replace('px',''),24);
    const headerShape=glass.dataset.centrixGlassShape||'rounded';
    const headerRimSize=clamp(num(glassCSS.getPropertyValue('--centrix-glass-rim-size').trim().replace('px',''),9),1,18);
    const headerShadowAlpha=clamp(num(glassCSS.getPropertyValue('--centrix-glass-shadow-alpha'),.28),0,.7);
    const headerLensOpacity=clamp(num(glassCSS.getPropertyValue('--centrix-glass-lens-opacity'),.7),0,1);
    const headerBorder=['current','borderless','edge_free'].includes(glass.dataset.centrixBorderStyle)?glass.dataset.centrixBorderStyle:'current';
    const headerEdge=['smooth','subtle','off'].includes(glass.dataset.centrixGlassEdgeStyle)?glass.dataset.centrixGlassEdgeStyle:'smooth';
    const headerText=glass.dataset.centrixGlassTextColor||'#ffffff';
    const headerMode=glass.dataset.centrixWarpMode||'off';
    const headerWarp=clamp(num(glass.dataset.centrixWarpStrength,0),0,100);
    const headerWarpBand=clamp(num(glass.dataset.centrixWarpBand,22),5,65);

    const popupTint=inherit?headerTint:(config.tint||'#202731');
    const popupOpacity=inherit?headerOpacity:clamp(num(config.opacity,48)/100,0,1);
    const blur=inherit?headerBlur:clamp(num(config.blur,12),0,45);
    const popupText=inherit?headerText:(config.text||'#ffffff');
    const popupBorder=inherit?headerBorder:config.borderStyle;
    const borderStyle=['current','borderless','edge_free'].includes(popupBorder)?popupBorder:'current';
    const edgeStyle=inherit?headerEdge:'smooth';
    const rim=inherit?headerRimSize:clamp(num(config.rim,6),1,18);
    const dim=clamp(num(config.dim,22)/100,0,.75);
    const duration=clamp(num(config.duration,450),200,1000);
    const offset=clamp(num(config.offset,12),0,48);
    const widthInset=clamp(num(config.inset,12),0,45);
    const desktopPopup=summary.matches?.('.centrix-desktop-glass-trigger')===true;
    const viewportW=window.visualViewport?.width||window.innerWidth;
    const viewportH=window.visualViewport?.height||window.innerHeight;
    const headerRect=(document.getElementById('header-component')||glass).getBoundingClientRect();
    const top=clamp(headerRect.bottom+offset,10,viewportH-130);
    const heightPct=clamp(num(desktopPopup?config.desktopHeight:config.height,desktopPopup?70:78),40,95);
    const maxHeight=Math.max(90,viewportH-top-12);
    const height=Math.max(90,Math.min(maxHeight,viewportH*heightPct/100));
    /* v2.0: never reset an OPEN adaptive popup to maximum height on
       Samsung/Android visualViewport resize. Keep its actual measured height. */
    const previousHeight=num(parseFloat(dialog?.style.getPropertyValue('--centrix-popup-height')),height);
    const effectiveHeight=(dialog?.open&&config.autoHeight!==false)
      ?Math.min(height,Math.max(90,previousHeight)):height;
    const width=desktopPopup
      ?Math.max(160,Math.min(clamp(num(config.desktopWidth,520),320,880),viewportW-widthInset*2))
      :Math.max(160,viewportW-widthInset*2);
    /* A tall navigation sheet needs readable corners. A pill-shaped header
       is interpreted as proportionally generous popup corners (32-64px),
       rather than clipping the entire menu behind 999px capsule corners. */
    const popupRadius=inherit
      ?(headerShape==='pill'?clamp(headerRect.height/2,32,64):clamp(headerRadiusRaw,0,64))
      :clamp(num(config.radius,30),0,64);
    const summaryRect=summary.getBoundingClientRect();
    const left=desktopPopup
      ?clamp(summaryRect.left-6,widthInset,Math.max(widthInset,viewportW-width-widthInset))
      :widthInset;
    const originX=clamp(summaryRect.left+summaryRect.width/2-left,10,width-10);
    const warp=inherit?headerWarp:clamp(num(config.warpStrength,60),0,100);
    const warpEnabled=inherit?headerMode==='fisheye'&&headerWarp>0:config.refraction!==false;
    const warpBand=inherit?headerWarpBand:clamp(popupRadius+16,12,45);
    const shadowAlpha=inherit?headerShadowAlpha:.30;

    dialog.dataset.centrixBorderStyle=borderStyle;
    dialog.dataset.centrixEdgeStyle=edgeStyle;
    dialog.dataset.centrixAppearanceSync=inherit?'true':'false';
    dialog.dataset.centrixPopupRenderMode=config.renderMode==='advanced'?'advanced':'stable';
    dialog.dataset.centrixPopupLayout=desktopPopup?'desktop':'mobile';
    for(const [key,val] of Object.entries({
      '--centrix-popup-top':top+'px',
      '--centrix-popup-left':left+'px',
      '--centrix-popup-width':width+'px',
      '--centrix-popup-height':effectiveHeight+'px',
      '--centrix-popup-height-cap':height+'px',
      '--centrix-popup-resize-time':clamp(num(config.resizeDuration,280),120,600)+'ms',
      '--centrix-popup-radius':popupRadius+'px',
      '--centrix-popup-origin-x':originX+'px',
      '--centrix-popup-blur':blur+'px',
      '--centrix-popup-tint':popupTint,
      '--centrix-popup-opacity':String(popupOpacity),
      '--centrix-popup-dim':String(dim),
      '--centrix-popup-backdrop-blur':clamp(num(config.backdropBlur,3),0,16)+'px',
      '--centrix-popup-duration':duration+'ms',
      '--centrix-popup-rim':rim+'px',
      '--centrix-popup-lens-opacity':String(inherit?headerLensOpacity:1),
      '--centrix-popup-shadow-alpha':String(shadowAlpha),
      '--centrix-popup-text':popupText,
      '--centrix-popup-toggle-top':summaryRect.top+'px',
      '--centrix-popup-toggle-left':summaryRect.left+'px',
      '--centrix-popup-toggle-width':summaryRect.width+'px',
      '--centrix-popup-toggle-height':summaryRect.height+'px'
    }))setStyle(dialog,key,val);
    return {width,height,radius:popupRadius,duration,warp,warpEnabled,warpBand};
  }
  function generateLensMap({width,height,radius,warp,warpEnabled,warpBand}){
    if(currentSettings()?.renderMode!=='advanced'||!chromium||!warpEnabled||warp<=0||reducedMotion.matches){
      if(dialog.dataset.centrixPopupRefraction!=='false')dialog.dataset.centrixPopupRefraction='false';
      return;
    }
    const w=Math.round(width),h=Math.round(height);
    if(!w||!h)return;
    if(!refrFilter){
      refrSvg=document.createElementNS(svgNS,'svg');
      refrSvg.setAttribute('width','0');refrSvg.setAttribute('height','0');
      refrSvg.style.cssText='position:absolute;width:0;height:0;pointer-events:none';
      const defs=document.createElementNS(svgNS,'defs');
      refrFilter=document.createElementNS(svgNS,'filter');
      refrFilter.setAttribute('id','centrix-popup-lens-v16');
      refrFilter.setAttribute('x','0');refrFilter.setAttribute('y','0');
      refrFilter.setAttribute('width','100%');refrFilter.setAttribute('height','100%');
      refrFilter.setAttribute('color-interpolation-filters','sRGB');
      refrImage=document.createElementNS(svgNS,'feImage');
      refrImage.setAttribute('x','0');refrImage.setAttribute('y','0');
      refrImage.setAttribute('width','100%');refrImage.setAttribute('height','100%');
      refrImage.setAttribute('preserveAspectRatio','none');
      refrImage.setAttribute('result','centrix-popup-map');
      refrDisplacement=document.createElementNS(svgNS,'feDisplacementMap');
      refrDisplacement.setAttribute('in','SourceGraphic');
      refrDisplacement.setAttribute('in2','centrix-popup-map');
      refrDisplacement.setAttribute('xChannelSelector','R');
      refrDisplacement.setAttribute('yChannelSelector','G');
      refrFilter.append(refrImage,refrDisplacement);defs.append(refrFilter);refrSvg.append(defs);document.body.append(refrSvg);
    }
    const cw=clamp(Math.round(w*.66),110,600),ch=clamp(Math.round(h*.55),120,540);
    const canvas=document.createElement('canvas');canvas.width=cw;canvas.height=ch;
    const ctx=canvas.getContext('2d');if(!ctx)return;
    const img=ctx.createImageData(cw,ch);
    const r=clamp(radius,0,Math.min(w,h)/2),band=clamp(num(warpBand,Math.max(12,Math.min(45,r+16))),5,65);
    const sdf=(x,y)=>{const dx=Math.abs(x-w/2)-(w/2-r),dy=Math.abs(y-h/2)-(h/2-r);return Math.hypot(Math.max(dx,0),Math.max(dy,0))+Math.min(Math.max(dx,dy),0)-r;};
    for(let y=0;y<ch;y++)for(let x=0;x<cw;x++){
      const px=(x+.5)*w/cw,py=(y+.5)*h/ch,dist=sdf(px,py);
      let red=128,green=128;
      if(dist<0){
        const gx=sdf(px+1.5,py)-sdf(px-1.5,py);
        const gy=sdf(px,py+1.5)-sdf(px,py-1.5);
        const mag=Math.hypot(gx,gy)||1;
        const t=clamp(1+dist/band,0,1);const edge=t*t*(3-2*t);
        red=clamp(Math.round(128-(gx/mag)*edge*50),0,255);
        green=clamp(Math.round(128-(gy/mag)*edge*50),0,255);
      }
      const i=(y*cw+x)*4;img.data[i]=red;img.data[i+1]=green;img.data[i+2]=128;img.data[i+3]=255;
    }
    ctx.putImageData(img,0,0);
    refrImage.setAttribute('href',canvas.toDataURL('image/png'));
    refrDisplacement.setAttribute('scale',String(clamp(warp,0,100)*.47));
    dialog.dataset.centrixPopupRefraction='true';
  }

  /* Compute the content's natural height from the inner UL, never from the
     currently stretched scroll viewport. That avoids the former empty 78vh menu.
     The nav becomes independently scrollable only when the cap is exceeded. */
  function updateAdaptiveHeight({instant=false}={}){
    if(!dialog?.open)return;
    const config=currentSettings();
    if(!config)return;
    const nav=dialog.querySelector('.centrix-floating-menu-v16__navigation');
    const list=nav?.querySelector(':scope > .centrix-floating-menu-v16__list');
    const bar=dialog.querySelector('.centrix-floating-menu-v16__toolbar');
    if(!nav||!list||!bar)return;
    const cap=Math.max(90,num(dialog.style.getPropertyValue('--centrix-popup-height-cap').replace('px',''),420));
    let target=cap;
    if(config.autoHeight!==false){
      const ns=getComputedStyle(nav);
      const paddingY=num(parseFloat(ns.paddingTop),12)+num(parseFloat(ns.paddingBottom),28);
      const barHeight=Math.ceil(bar.getBoundingClientRect().height);
      const listHeight=Math.ceil(list.scrollHeight);
      const below=clamp(num(config.bottomSpace,12),0,40);
      const natural=Math.ceil(barHeight+paddingY+listHeight+below+2);
      target=clamp(natural,Math.min(90,cap),cap);
    }
    const before=num(dialog.style.getPropertyValue('--centrix-popup-height').replace('px',''),cap);
    if(Math.abs(before-target)<1)return;
    dialog.style.setProperty('--centrix-popup-height',target+'px');
    if(!instant&&config.renderMode==='advanced'&&
       dialog.classList.contains('centrix-floating-menu-v16--visible')){
      /* Experimental fisheye only. Stable mode never swaps any backdrop filter
         on submenu expansion or animated menu growth. */
      cancelDeferredRefraction();
      if(lastLens){
        const wait=clamp(num(config.resizeDuration,280),120,600)
          +clamp(num(config.refractionDelay,150),0,500);
        deferRefraction(lastLens,wait);
      }
    }
  }
  function cancelDeferredRefraction(){
    ++refractionEpoch;
    clearTimeout(refractionTimer);
    refractionTimer=0;
    if(dialog&&dialog.dataset.centrixPopupRefraction!=='false'){
      dialog.dataset.centrixPopupRefraction='false';
    }
  }
  /* Frosted blur + tint stay active throughout the bubble transition.
     Generate and apply SVG displacement ONLY after its compositor settles. */
  function deferRefraction(lens,wait){
    cancelDeferredRefraction();
    if(currentSettings()?.renderMode!=='advanced'||!lens?.warpEnabled||!chromium||reducedMotion.matches)return;
    const epoch=refractionEpoch;
    const delay=clamp(num(wait,0),0,2000);
    refractionTimer=setTimeout(()=>{
      refractionTimer=0;
      requestAnimationFrame(()=>{
        if(epoch!==refractionEpoch||!dialog?.open||
           !dialog.classList.contains('centrix-floating-menu-v16--visible'))return;
        const measuredHeight=num(dialog.style.getPropertyValue('--centrix-popup-height').replace('px',''),lens.height);
        /* Rebuild the map using the final settled panel dimensions. */
        generateLensMap({...lens,height:measuredHeight});
      });
    },delay);
  }

  function refreshGeometry(){
    if(!dialog?.open||!trigger?.isConnected)return;
    const config=currentSettings(),glass=findGlass();if(!config||!glass)return;
    /* Viewport resize while a modal is open can happen repeatedly on mobile.
       Stable mode updates dimensions ONLY, without touching filters. */
    if(config.renderMode==='advanced')cancelDeferredRefraction();
    const lens=styleDialog(config,trigger,glass);
    lastLens=lens;
    updateAdaptiveHeight({instant:true});
    if(config.renderMode==='advanced'&&
       dialog.classList.contains('centrix-floating-menu-v16--visible')){
      deferRefraction(lens,clamp(num(config.refractionDelay,150),0,500)+150);
    }
  }
  /* Keep native Shopify details state closed during floating popup. */
  function restoreHamburger(summary){
    if(!summary)return;
    if(summary.matches?.('.centrix-desktop-glass-trigger')){
      const expanded=Boolean(dialog?.open&&dialog.dataset.centrixPopupClosing!=='true');
      summary.setAttribute('aria-expanded',String(expanded));
      summary.setAttribute('aria-label',expanded?'Close floating navigation menu':'Open floating navigation menu');
      return;
    }
    const details=summary.closest('details');
    if(details){
      details.removeAttribute('open');
      details.classList.remove('menu-open');
    }
    summary.closest('header-drawer')?.querySelector('.menu-drawer')?.classList.remove('menu-drawer--has-submenu-opened');
    summary.setAttribute('aria-expanded','false');
  }
  function openPopup(summary){
    const links=readJson('.centrix-floating-menu-v16__links');
    const config=currentSettings(),glass=findGlass();
    if(!config||!glass||!Array.isArray(links)||!links.length)return false;
    clearTimeout(hideTimer);
    const el=ensureDialog();
    el.classList.remove('centrix-floating-menu-v16--visible');
    /* v2.1: reset the previous exit state before opening a new popup. */
    el.dataset.centrixPopupClosing='false';
    trigger=summary;
    restoreHamburger(summary);
    document.documentElement.dataset.centrixPopupV17Open='true';
    const navigation=el.querySelector('.centrix-floating-menu-v16__navigation');
    navigation.replaceChildren();
    const list=node('ul','centrix-floating-menu-v16__list');
    appendLinks(links,list);navigation.append(list);
    cancelDeferredRefraction();
    const lens=styleDialog(config,summary,glass);
    lastLens=lens;
    el.dataset.centrixPopupRefraction='false';
    if(!el.open)el.showModal();
    /* Measure with the real rendered font and links, before revealing panel. */
    updateAdaptiveHeight({instant:true});
    const epoch=refractionEpoch;
    /* Accessibility: native details is not expanded; modal has its own toggle.
       The popup becomes visible only after the compact height is established. */
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
      if(!el.open||refractionEpoch!==epoch)return;
      restoreHamburger(summary);
      el.classList.add('centrix-floating-menu-v16--visible');
      const entrance=reducedMotion.matches?0:clamp(num(config.duration,450),200,1000);
      const settleDelay=clamp(num(config.refractionDelay,150),0,500);
      if(config.renderMode==='advanced'){
        deferRefraction(lens,entrance+settleDelay);
      }
    }));
    el.querySelector('.centrix-floating-menu-v16__close')?.focus({preventScroll:true});
    return true;
  }
  function closePopup(instant=false){
    if(!dialog?.open)return;
    /* Ignore double taps while the sheet is already reversing, unless this
       is a mandatory immediate cleanup during navigation/theme teardown. */
    if(dialog.dataset.centrixPopupClosing==='true'&&!instant)return;
    cancelDeferredRefraction();
    clearTimeout(hideTimer);
    const config=currentSettings();
    const isStable=config?.renderMode!=='advanced';
    /* Stable mode previously left a fully opaque backdrop sampler visible
       throughout the entire 450ms closure, creating the lingering blur box.
       Coordinate glass, tint, text and scrim on ONE 260ms-ish exit timeline. */
    const exitMs=instant||reducedMotion.matches
      ?0
      :isStable
        ?clamp(Math.round(num(config?.duration,450)*.58),140,350)
        :clamp(num(config?.duration,450),200,1000);
    setStyle(dialog,'--centrix-popup-exit-time',exitMs+'ms');
    dialog.dataset.centrixPopupClosing='true';
    dialog.classList.remove('centrix-floating-menu-v16--visible');
    const onFinish=()=>{
      if(!dialog?.open)return;
      dialog.close();
      dialog.dataset.centrixPopupClosing='false';
      dialog.dataset.centrixPopupRefraction='false';
      delete document.documentElement.dataset.centrixPopupV17Open;
      /* Reconcile the header SVG map once the popup's backdrop is gone. */
      document.dispatchEvent(new Event('centrix:popup-closed'));
      if(trigger?.isConnected){
        restoreHamburger(trigger);
        if(!trigger.matches?.('.centrix-desktop-glass-trigger')){
          trigger.removeAttribute('aria-controls');
          trigger.removeAttribute('aria-haspopup');
        }
        trigger.focus({preventScroll:true});
      }
    };
    /* One extra frame lets the compositor paint the final 0-opacity state.
       It does NOT leave an opaque blur surface behind during this interval. */
    if(exitMs===0)onFinish();
    else hideTimer=setTimeout(onFinish,exitMs+24);
  }
  document.addEventListener('click',e=>{
    const summary=e.target.closest?.('#header-component .header__drawer .menu-drawer-container > summary.header__icon--menu, #header-component .centrix-desktop-glass-trigger');
    if(!summary||!canUsePopup(summary))return;
    e.preventDefault();e.stopImmediatePropagation();
    if(dialog?.open){closePopup();return;}
    restoreHamburger(summary);
    openPopup(summary);
  },true);
  document.addEventListener('keydown',e=>{
    if(e.key!=='Enter'&&e.key!==' ')return;
    const summary=e.target.closest?.('#header-component .header__drawer .menu-drawer-container > summary.header__icon--menu, #header-component .centrix-desktop-glass-trigger');
    if(!summary||!canUsePopup(summary))return;
    e.preventDefault();e.stopImmediatePropagation();
    if(dialog?.open){closePopup();return;}
    restoreHamburger(summary);
    openPopup(summary);
  },true);
  const scheduleGeometryRefresh=()=>{
    if(!dialog?.open||resizeFrame)return;
    resizeFrame=requestAnimationFrame(()=>{
      resizeFrame=0;
      if(dialog?.open)refreshGeometry();
    });
  };
  window.addEventListener('resize',scheduleGeometryRefresh,{passive:true});
  window.visualViewport?.addEventListener('resize',scheduleGeometryRefresh,{passive:true});
  document.addEventListener('shopify:section:load',()=>closePopup(true));
  document.addEventListener('shopify:section:unload',()=>closePopup(true));
  window.addEventListener('pagehide',()=>closePopup(true));
})();
